(() => {
  "use strict";

  // 1. State Variable (Much faster than searching innerHTML)
  let isRecaptchaLoaded = false;

  // 2. The Loading Logic
  const loadRecaptcha = () => {
    // If already loaded, stop here.
    if (isRecaptchaLoaded) return;

    // A. Create and append the script
    const script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js';
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);

    // B. Handle the UI classes
    const spamMsg = document.querySelector('.form_spam');
    if (spamMsg) {
        spamMsg.classList.add('shown');
    }

    // C. Update State so we don't do this again
    isRecaptchaLoaded = true;
    
    // D. Cleanup: Remove the event listeners so they don't fire again
    removeListeners();
  };

  // 3. Event Listeners (Trigger on user interaction)
  // We attach these to the specific form inputs or the form itself 
  // to be efficient, but document-level is fine for simplicity.
  const formInputs = document.querySelectorAll('input, textarea');
  
  const addListeners = () => {
    formInputs.forEach(input => {
      // Trigger on focus (tabbing in) or click/touch
      input.addEventListener('focus', loadRecaptcha, { passive: true });
      input.addEventListener('click', loadRecaptcha, { passive: true });
    });
  };

  const removeListeners = () => {
    formInputs.forEach(input => {
      input.removeEventListener('focus', loadRecaptcha);
      input.removeEventListener('click', loadRecaptcha);
    });
  };

  // Initialize
  if (formInputs.length > 0) {
    addListeners();
  }

})();